import deviceInfo from "../assets/apps/device-info.webp";
import apkExtractor from "../assets/apps/apk-extractor.webp";
import jeeMains from "../assets/apps/jee-mains.webp";
import jeeAdvanced from "../assets/apps/jee-advanced.webp";
import neet from "../assets/apps/neet.webp";
import aiims from "../assets/apps/aiims.webp";
import chemistry from "../assets/apps/chemistry.webp";
import hcVerma from "../assets/apps/hc-verma.webp";
import maths from "../assets/apps/maths.webp";
import physics from "../assets/apps/physics.webp";

export const apps = [
  {
    id: 0,
    image: deviceInfo,
    name: "Device Info",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.deviceinfo",
    desc: "Device Info is a user-friendly Android application that gives you complete and detailed information about your mobile device with best user-interface. Device Info is packed with many features to give all info of software and hardware of your android device like CPU, RAM, OS, Sensors, Storage, Battery, Bluetooth, Apps, Display, Camera, Thermal, Codecs, Inputs.",
  },
  {
    id: 1,
    image: apkExtractor,
    name: "APK Extractor",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.apkextractor",
    desc: "Apk Extractor is a fast and lightweight app to extract apk & the app icons from apps on your device. It works fast and is easy to use and can extract both System and Installed Apps",
  },
  {
    id: 2,
    image: jeeMains,
    name: "JEE Main Solved Papers Offline",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.jeemains",
    desc: "This app is a complete package for those who want to prepare for JEE Main 2021 with Previous years Solved and Unsolved papers. It also contains subject wise syllabus of JEE Main 2021. Download feature is available for JEE Main Unsolved Papers, so that you can download the unsolved papers, use them in dark mode, and share and practice with the hardcopies.",
  },
  {
    id: 3,
    image: jeeAdvanced,
    name: "JEE Advanced Solved Papers",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.jeemains",
    desc: "This app contains the solutions of papers for India's toughest exam in Engineering Category i.e. JEE Advanced.",
  },
  {
    id: 4,
    image: neet,
    name: "NEET Solved Papers Offline",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.neetpapers",
    desc: "Neet Solved Papers (Offline) app contains both Solved and Unsolved papers of NEET/ AIPMT from 1998-2020. It also contains many important features to help students and also contains syllabus of NEET 2021.",
  },
  {
    id: 5,
    image: aiims,
    name: "AIIMS Solved Papers Offline",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.aiimspapers",
    desc: "All India Institute of Medical Sciences Entrance Test or AIIMS is an entrance examination in India, for students who wish to study any graduate medical course (MBBS). Aspirants who are preparing for the AIIMS can read and practice the AIIMS 26 Previous Year Question Papers 1994-2019 from this app.",
  },
  {
    id: 6,
    image: physics,
    name: "Physics Notes for JEE and NEET",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.phynotes",
    desc: "This app contains all the chapters of Physics NCERT in helpful manner for JEE, NEET and Board Exams of class 12th. This app is helpful for Students and Teachers.",
  },
  {
    id: 7,
    image: chemistry,
    name: "Chemistry Notes for JEE & NEET",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.chemnotes",
    desc: "This app contains all the notes of chapters to help students preparing for JEE Mains, JEE Advanced, NEET, AIIMS, 11-12th Board Exams. It is completely free and works offline . It also helps college grade students.",
  },
  {
    id: 8,
    image: maths,
    name: "Maths Notes for JEE Offline",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.mathsnotes",
    desc: "This app helps students preparing for JEE Mains , JEE Advanced or 11-12th Exams. It also helps college grade student and teachers for preparing notes. These notes are robust and on to the point.",
  },
  {
    id: 9,
    image: hcVerma,
    name: "HC Verma Solutions Offline",
    link: "https://play.google.com/store/apps/details?id=com.toralabs.hcvsolutions",
    desc: "This App contains explained solutions of both part 1 and part 2 of Concepts of Physics a book by HC Verma in an offline mode. It will help students those who are in 11th and 12th and are preparing for IIT-JEE.",
  },
];
